import * as Types from '../../../../../data/workbench-api/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MemberRowOptionsFragment = { __typename?: 'BusinessUser', organisationId: string, accountId: number, created: string, status: Types.BusinessUserStatus, inviteExpired?: boolean | null, email?: string | null, id: string, inviteSecret: string };

export type UpdateMemberStatusMutationVariables = Types.Exact<{
  inviteSecret: Types.Scalars['String']['input'];
  status: Types.BusinessUserStatus;
}>;


export type UpdateMemberStatusMutation = { __typename?: 'Mutation', updateBusinessUserByInviteSecret?: { __typename?: 'UpdateBusinessUserPayload', businessUser?: { __typename?: 'BusinessUser', organisationId: string, accountId: number, created: string, status: Types.BusinessUserStatus, inviteExpired?: boolean | null, email?: string | null, id: string, inviteSecret: string } | null } | null };

export type DeleteMemberMutationVariables = Types.Exact<{
  inviteSecret: Types.Scalars['String']['input'];
}>;


export type DeleteMemberMutation = { __typename?: 'Mutation', deleteBusinessUserByInviteSecret?: { __typename?: 'DeleteBusinessUserPayload', businessUser?: { __typename?: 'BusinessUser', organisationId: string, accountId: number, created: string, status: Types.BusinessUserStatus, inviteExpired?: boolean | null, email?: string | null, id: string, inviteSecret: string } | null } | null };

export type ResendInviteEmailMutationVariables = Types.Exact<{
  organisationId: Types.Scalars['String']['input'];
  id: Types.Scalars['String']['input'];
}>;


export type ResendInviteEmailMutation = { __typename?: 'Mutation', resendInviteEmail?: { __typename?: 'ResendInviteEmailPayload', businessUser?: { __typename?: 'BusinessUser', organisationId: string, accountId: number, created: string, status: Types.BusinessUserStatus, inviteExpired?: boolean | null, email?: string | null, id: string, inviteSecret: string } | null } | null };

export const MemberRowOptionsFragmentDoc = gql`
    fragment MemberRowOptions on BusinessUser {
  organisationId
  accountId
  created
  status
  inviteExpired
  email
  id
  inviteSecret
}
    `;
export const UpdateMemberStatusDocument = gql`
    mutation UpdateMemberStatus($inviteSecret: String!, $status: BusinessUserStatus!) {
  updateBusinessUserByInviteSecret(
    input: {inviteSecret: $inviteSecret, patch: {status: $status}}
  ) {
    businessUser {
      ...MemberRowOptions
    }
  }
}
    ${MemberRowOptionsFragmentDoc}`;

/**
 * __useUpdateMemberStatusMutation__
 *
 * To run a mutation, you first call `useUpdateMemberStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMemberStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMemberStatusMutation, { data, loading, error }] = useUpdateMemberStatusMutation({
 *   variables: {
 *      inviteSecret: // value for 'inviteSecret'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateMemberStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMemberStatusMutation, UpdateMemberStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMemberStatusMutation, UpdateMemberStatusMutationVariables>(UpdateMemberStatusDocument, options);
      }
export type UpdateMemberStatusMutationHookResult = ReturnType<typeof useUpdateMemberStatusMutation>;
export type UpdateMemberStatusMutationResult = Apollo.MutationResult<UpdateMemberStatusMutation>;
export type UpdateMemberStatusMutationOptions = Apollo.BaseMutationOptions<UpdateMemberStatusMutation, UpdateMemberStatusMutationVariables>;
export const DeleteMemberDocument = gql`
    mutation DeleteMember($inviteSecret: String!) {
  deleteBusinessUserByInviteSecret(input: {inviteSecret: $inviteSecret}) {
    businessUser {
      ...MemberRowOptions
    }
  }
}
    ${MemberRowOptionsFragmentDoc}`;

/**
 * __useDeleteMemberMutation__
 *
 * To run a mutation, you first call `useDeleteMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMemberMutation, { data, loading, error }] = useDeleteMemberMutation({
 *   variables: {
 *      inviteSecret: // value for 'inviteSecret'
 *   },
 * });
 */
export function useDeleteMemberMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMemberMutation, DeleteMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMemberMutation, DeleteMemberMutationVariables>(DeleteMemberDocument, options);
      }
export type DeleteMemberMutationHookResult = ReturnType<typeof useDeleteMemberMutation>;
export type DeleteMemberMutationResult = Apollo.MutationResult<DeleteMemberMutation>;
export type DeleteMemberMutationOptions = Apollo.BaseMutationOptions<DeleteMemberMutation, DeleteMemberMutationVariables>;
export const ResendInviteEmailDocument = gql`
    mutation ResendInviteEmail($organisationId: String!, $id: String!) {
  resendInviteEmail(input: {organisationId: $organisationId, id: $id}) {
    businessUser {
      ...MemberRowOptions
    }
  }
}
    ${MemberRowOptionsFragmentDoc}`;

/**
 * __useResendInviteEmailMutation__
 *
 * To run a mutation, you first call `useResendInviteEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInviteEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInviteEmailMutation, { data, loading, error }] = useResendInviteEmailMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendInviteEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendInviteEmailMutation, ResendInviteEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendInviteEmailMutation, ResendInviteEmailMutationVariables>(ResendInviteEmailDocument, options);
      }
export type ResendInviteEmailMutationHookResult = ReturnType<typeof useResendInviteEmailMutation>;
export type ResendInviteEmailMutationResult = Apollo.MutationResult<ResendInviteEmailMutation>;
export type ResendInviteEmailMutationOptions = Apollo.BaseMutationOptions<ResendInviteEmailMutation, ResendInviteEmailMutationVariables>;